import {Toast} from "primereact/toast";
import React, { useRef} from "react";
import {UseLoader} from "../../../hooks/useLoader";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {useForm} from "react-hook-form";
import {guardarData} from "../../../api/tercero.service";
import {confirmDialog} from "primereact/confirmdialog";


export const ModalNuevoTercero= ({show, hide}) => {

    const [handleLoader] = UseLoader();

    const {register, handleSubmit, formState: {errors}} = useForm();

    const toast = useRef(null);

    const onSubmit= async payload => {
        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoader(true);
                    const response= await guardarData(payload);
                    const data= await response.data;
                    //console.log(data)

                    handleLoader(false);
                    if (data.estado !== 200) {
                        toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            });
        } catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }



    return(
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Crear nuevo pensionado" visible={show} style={{width: '90vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                            <h6 className="title-modal">
                                Información tercero
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="pres"
                                    >
                                        Nombre *
                                    </label>

                                    <input
                                        {...register("nombre", {required: true, maxLength: 100 })}
                                        id="nombre"
                                        type="text"
                                        className="form-input-small"
                                    />
                                    {errors.nombre?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.nombre?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 100 caracteres</span>}

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado *
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        {...register("estado", {required: true })}
                                        id="estado">
                                        <option value="">Seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>
                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    )
}
